import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "allmark.sidebar.collapsed";

export function useSidebarCollapsed(): {
  collapsed: boolean;
  toggle: () => void;
  setCollapsed: (next: boolean) => void;
} {
  const [collapsed, setCollapsedState] = useState<boolean>(() => {
    const stored =
      typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
    if (stored === "0") return false;
    if (stored === "1") return true;
    return true; // default: collapsed
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, collapsed ? "1" : "0");
  }, [collapsed]);

  const toggle = useCallback(() => setCollapsedState((c) => !c), []);
  const setCollapsed = useCallback(
    (next: boolean) => setCollapsedState(next),
    [],
  );

  return { collapsed, toggle, setCollapsed };
}
